import { memo, VFC, useEffect, useState } from "react";
import {
  Modal,ModalOverlay,ModalContent,ModalFooter,ModalBody,ModalCloseButton,useDisclosure,
  Spinner,Center,ModalHeader,
} from '@chakra-ui/react';
import { PrimaryButton } from '../../atoms/button/PrimaryButton';
import { useLoginUser } from '../../../hooks/providers/useLoginUserProvider';
import { ErrorDialog } from "../../organisms/modal/ErrorDialog";
import { useIssue } from '../../../hooks/useIssue';
import { useOpelog } from '../../../hooks/useOpelog';
import { getIssueDiffParam } from '../../../types/issue';
import { GV_DIALOG_SIZE } from '../../../hooks/useConst';

type Props = {
  issueArn: string;
  // payerAccountId: string;
  reqType: string;
  baseHistory: string;
  compHistory: string;
  setReqType: (arg:string) => void;
};

export const IssueDiffDialog: VFC<Props> = memo((props) => {
  const { issueArn, reqType, baseHistory, compHistory, setReqType } = props;
  const title = '差分表示';
  const { loginUser } = useLoginUser();
  const { OutputOpelog } = useOpelog();
  const { getIssueDiff, issueDiffObj, executing, errObj } = useIssue();
  const { isOpen, onOpen } = useDisclosure();
  const [ closeFlag, setCloseFlag ] = useState(false);
  const [ execFlag, setExecFlag ] = useState(false);
  
    // API実行準備
  useEffect(() => {
    setExecFlag(true);
    !isOpen && onOpen();
    // eslint-disable-next-line 
  }, []);
  
  // 初期検索
  useEffect(() => {
    if( !execFlag ) return;
    
    setExecFlag(false);
    if (loginUser && issueArn && reqType && baseHistory && compHistory) {
      const option:getIssueDiffParam = {
        'health_arn': issueArn,
        // 'payer_account_id': payerAccountId,
        'req_Type': reqType,
        'old_history': baseHistory,
        'new_history': compHistory,
      }
      getIssueDiff(option);
      
      OutputOpelog('issue_diff', 'reference', "HEALTH_ARN#" + issueArn);
    }

  }, [execFlag,loginUser,issueArn,reqType,baseHistory,compHistory,getIssueDiff,OutputOpelog,isOpen,onOpen]);
  
  // エラーダイアログ表示後、本ダイアログも閉じる
  useEffect(() => {
    if( closeFlag ) setReqType('');
  }, [closeFlag]);
  
  return (
    <>
    {errObj && !closeFlag ? (
      <ErrorDialog errTitle={title} errObj={errObj} opeErrMes="" setCloseFlag={setCloseFlag} />
      
    ) : (
      <Modal
        isOpen={isOpen}
        onClose={()=>setReqType('')}
        motionPreset="slideInBottom"
        autoFocus={false}
        size={GV_DIALOG_SIZE}
        isCentered
        closeOnOverlayClick={false}
        scrollBehavior='inside'
        allowPinchZoom
      >
        <ModalOverlay />
        <ModalContent>
          <ModalHeader>障害履歴差分比較</ModalHeader>
          <ModalCloseButton />
          <ModalBody>
            {(issueDiffObj && issueDiffObj.html_text) ? (
              <div dangerouslySetInnerHTML={{__html: issueDiffObj.html_text}}></div>
            ) : (
              <Center h="80vh">
                <Spinner color="teal.500" />
              </Center>
            )}
          </ModalBody>
          
          <ModalFooter>
            <PrimaryButton type='ok' onClick={()=>setReqType('')} isLoading={executing}>
              閉じる
            </PrimaryButton>
          </ModalFooter>
        </ModalContent>
      </Modal>
    )}
    </>
  );
  
});
